/* Coordinate theme cart requests only. Shopify/Meta own analytics and CAPI IDs. */
(function () {
  if (window.LoncryCommerce) return;
  var active = null;
  var navigationTimer = null;

  function end(token) {
    if (!token || token !== active) return;
    window.clearTimeout(navigationTimer);
    navigationTimer = null;
    active = null;
    document.documentElement.removeAttribute('data-loncry-commerce-busy');
  }

  window.LoncryCommerce = {
    isBusy: function () { return active !== null; },
    begin: function (kind) {
      if (active) return null;
      active = { kind: kind };
      document.documentElement.setAttribute('data-loncry-commerce-busy', kind);
      return active;
    },
    end: end,
    navigation: function (token) {
      if (!token || token !== active) return;
      // Recover if navigation is cancelled. Never retry the successful request.
      window.clearTimeout(navigationTimer);
      navigationTimer = window.setTimeout(function () { end(token); }, 15000);
    }
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form || form.tagName !== 'FORM') return;
    var action;
    try { action = new URL(form.action, window.location.href); }
    catch (_) { return; }
    if (action.origin !== window.location.origin || !/\/cart\/?$/.test(action.pathname)) return;
    var submitter = event.submitter;
    if (submitter ? submitter.name !== 'checkout' : !form.querySelector('[name="checkout"]')) return;
    var token = window.LoncryCommerce.begin('checkout');
    if (!token) {
      event.preventDefault();
      return;
    }
    // Keep Shopify's native checkout POST and the enabled checkout submitter.
    window.LoncryCommerce.navigation(token);
  }, true);

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (active) end(active);
    document.documentElement.removeAttribute('data-cart-updating');
  });
})();
